import {
  getValueReduxUtil,
  PROFILE_KEY
} from '@gymaholic/packages'
import getByIdReduxSelector from 'modules/redux/selectors/get-by-id'
import getCurrentReduxSelector from 'modules/redux/selectors/get-current'
import isSavingReduxUtil from 'modules/redux/utils/is-saving'
import { PREFERENCES_MODEL_KEY } from 'modules/training/models/preferences/constants'
import { PREFERENCES_PATH } from 'modules/training/modules/preferences/constants'
import { setHoursMinutesAndSecondsDateUtil } from 'packages/src'
import { createSelector } from 'reselect'

const DEFAULT_TRAINING_TIME = '18:00'

export const getCurrentPreferencesSelect = getCurrentReduxSelector(
  PREFERENCES_PATH.DATA,
  PREFERENCES_PATH.CURRENT
)

export const getPreferenceByIdSelector = (id) => getByIdReduxSelector(
  PREFERENCES_PATH.DATA,
  id
)

export const getPreferencesIsSavingSelector = () => {
  return (state) => {
    const currentPreference = getCurrentPreferencesSelect(state)
    return isSavingReduxUtil(currentPreference)
  }
}

const getTrainingTimePreferencesSelect = createSelector(
  getCurrentPreferencesSelect,
  (preferencesParentObj) => {
    let preferences
    if (preferencesParentObj) {
      preferences = getValueReduxUtil(
        preferencesParentObj,
        PROFILE_KEY.PREFERENCES
      )
    }
    const time = getValueReduxUtil(
      preferencesParentObj,
      PREFERENCES_MODEL_KEY.TRAINING_TIME
    ) ||
      getValueReduxUtil(
        preferences,
        PREFERENCES_MODEL_KEY.TRAINING_TIME
      )
    return time ||
      DEFAULT_TRAINING_TIME
  }
)

export const getTrainingTimeDatePreferencesSelect = createSelector(
  getTrainingTimePreferencesSelect,
  (trainingTimeStr) => {
    let hours
    let minutes
    if (typeof trainingTimeStr === 'string') {
      [hours, minutes] = trainingTimeStr.split(':')
    } else {
      hours = trainingTimeStr
      minutes = 0
    }

    return setHoursMinutesAndSecondsDateUtil(
      new Date(),
      {
        hours,
        minutes,
        second: 0,
        millisecond: 0
      }
    )
  }
)
